import { render, staticRenderFns } from "./pricing.vue?vue&type=template&id=3749dd18&scoped=true&"
import script from "./pricing.vue?vue&type=script&lang=js&"
export * from "./pricing.vue?vue&type=script&lang=js&"
import style0 from "./pricing.vue?vue&type=style&index=0&id=3749dd18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3749dd18",
  null
  
)

export default component.exports